import { Component, OnInit, OnDestroy } from '@angular/core';
import { IxellAPIService, IColorUserV1, Roles, ICtcV1 } from '../../tools/api.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Utils } from '../../tools/utils';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { StorageService } from '../../tools/storage.service';
import { Constants } from '../../entities/Constants';
import { Router } from '@angular/router';
import { HeaderService } from '../../tools/header.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Component({
    selector: 'app-ManageColorUserV2',
    templateUrl: './manageColorUserV2.component.html',
    styleUrls: ['./manageColorUserV2.component.scss']
})
export class ManageColorUserV2 implements OnInit, OnDestroy {

    listOfBrands = [
        "Ixell",
        "Autocolor",
        "Cromax",
        "DeBeer",
        "Glasurit",
        "Lechler",
        "Lesonal",
        "Max Meyer",
        "PPG",
        "RM",
        "Sikkens",
        "Spie Hecker",
        "Standox",
        "Autre"
    ]

    displayedColumns = ["companySocialReason", "address", "firstName", "name", "mail", "sended", "action", "seeMore"];

    isPreprod: boolean;
    isAdminLacour: boolean;
    infoPreprod: boolean = false;

    role: Roles;
    Roles = Roles;

    customersLst: IColorUserV1[] = [];
    customersSource: any;

    //countries: any[] = Utils.countries();
    countries: any[] = [];
    noResults: boolean = false;
    emailExists: boolean = false;
    showOther: boolean = false;
    showOtherEdit: boolean = false;
    showEditForm: boolean = false;
    showMailForm: boolean = false;
    showCompanyForm: boolean = false;
    showListCompany: boolean = false;
    companySelected: any;
    companyEntered: IColorUserV1;
    dataCompanySelected: any;
    customerSelected: any;
    showVerifCompany: boolean = false;
    showCustomerCompany: boolean = false;
    showCustomerForm: boolean = false;
    newCustomer: boolean = false;
    mprRenault: boolean = false;
    mprRenaultOther: boolean = false;
    haveScale: boolean = false;
    currentCustomer: IColorUserV1;
    otherCustomer: IColorUserV1;
    deleteMailCustomer: IColorUserV1;
    deleteAccountCustomer: IColorUserV1;
    country: string;
    regions: string[] = [];
    languages: any[] = [];
    mailCustomer: string;
    emergencyMailCustomer: string;
    validationModal: boolean = false;
    envoiMailModal: boolean = false;
    confirmationDeleteAccount: boolean = false;
    confirmationDeleteMail: boolean = false;
    similarCustomers: IColorUserV1[];
    similarCompany: any[];
    isNewCompany: boolean = false;
    errorMsgMail: boolean = false;
    errorMsgCompany: boolean = false;
    errorMsgVerifCompany: boolean = false;
    errorMsgCustomer: boolean = false;
    msgConfirmation: boolean = false;
    ctcsFiltered: ICtcV1[] = [];
    checkedAnnuaire: boolean = false;
    annuaireIxell: boolean = false;

    //haveTwoMail: boolean = false;
    haveMailPrincipal: boolean = false;
    checkBoxMailPrincipal: boolean = false;
    haveMailSecondaire: boolean = false;
    checkBoxMailSecondaire: boolean = false;
    changeMailPrincipal: string = "";
    haveChangeMailPrincipal: boolean = false;
    tmpCurrentCustomerMail: string = "";

    lastConnectionDate: string = "";
    availableCTCs: ICtcV1[] = [];

    seeMoreCustomer: IColorUserV1 | null = null;

    private searchCustomersSub: any;
    private checkMailSub: any;
    private saveAndSendIDSub: any;
    private saveSub: any;
    private regionsSub: any;
    private hiddeCustomerSub: any;
    private deleteDateMailSub: any;
    private getCustomerSub: any;
    private roleSub: any;
    private getSimilarCompanySub: any;
    private getCustomersCompanySub: any;
    private getCtcSub: any;
    private autoCoSub: any;
    private statsGetLastConnectionSub: any;
    private languageChangeSub: any;
    private getLstCtcByCountrySub: any;

    searchCustomerForm = new UntypedFormGroup({
        country: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        clientFilter: new UntypedFormControl('', [Validators.required]),
        clientOfId: new UntypedFormControl('')
    });

    editCustomerForm = new UntypedFormGroup({
        email: new UntypedFormControl('', Validators.compose([
            Validators.required,
            Validators.pattern('[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,}')
        ])),
        name: new UntypedFormControl('', [Validators.required]),
        firstName: new UntypedFormControl('', [Validators.required]),
        mobile: new UntypedFormControl('', [Validators.required]),
        phone: new UntypedFormControl(''),
        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),
        language: new UntypedFormControl('', [Validators.required]),

        ctc: new UntypedFormControl(''),
        idCtc: new UntypedFormControl('', [Validators.required]),

        businessCode: new UntypedFormControl(''),
        customerNumber: new UntypedFormControl('', [Validators.required]),
        customerCode: new UntypedFormControl('', [Validators.required]),
        compteTresor: new UntypedFormControl('', [Validators.required]),
        haveScale: new UntypedFormControl(''),
        paintBrand: new UntypedFormControl(''),
        emergencyMail: new UntypedFormControl('', Validators.compose([
            Validators.pattern('[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,}')
        ])),

        siren: new UntypedFormControl(''),
        tva: new UntypedFormControl('')
    });

    otherCustomerForm = new UntypedFormGroup({
        name: new UntypedFormControl('', [Validators.required]),
        firstName: new UntypedFormControl('', [Validators.required]),
        mobile: new UntypedFormControl('', [Validators.required]),
        phone: new UntypedFormControl(''),
        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),
        language: new UntypedFormControl('', [Validators.required]),

        ctc: new UntypedFormControl(''),
        idCtc: new UntypedFormControl('', [Validators.required]),

        businessCode: new UntypedFormControl('', [Validators.required]),
        customerNumber: new UntypedFormControl('', [Validators.required]),
        customerCode: new UntypedFormControl('', [Validators.required]),
        compteTresor: new UntypedFormControl('', [Validators.required]),

        siren: new UntypedFormControl(''),
        tva: new UntypedFormControl('')
    });

    customerEmailForm = new UntypedFormGroup({
        email: new UntypedFormControl('', Validators.compose([
            Validators.required,
            Validators.pattern('[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,}')
        ]))
    });

    companyForm = new UntypedFormGroup({
        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),

        siren: new UntypedFormControl(''),
        tva: new UntypedFormControl('')

    });

    similarCompanyForm = new UntypedFormGroup({
        similarCompany: new UntypedFormControl('', [Validators.required])
    });

    dataCompanyForm = new UntypedFormGroup({
        dataCompany: new UntypedFormControl('', [Validators.required])
    });

    customerCompanyForm = new UntypedFormGroup({
        customerCompany: new UntypedFormControl('', [Validators.required])
    });

    customerForm = new UntypedFormGroup({
        name: new UntypedFormControl('', [Validators.required]),
        firstName: new UntypedFormControl('', [Validators.required]),
        mobile: new UntypedFormControl('', [Validators.required]),
        phone: new UntypedFormControl(''),
        language: new UntypedFormControl('', [Validators.required]),

        ctc: new UntypedFormControl(''),
        idCtc: new UntypedFormControl('', [Validators.required]),

        businessCode: new UntypedFormControl(''),
        customerNumber: new UntypedFormControl('', [Validators.required]),
        customerCode: new UntypedFormControl('', [Validators.required]),
        compteTresor: new UntypedFormControl('', [Validators.required]),
        haveScale: new UntypedFormControl(''),
        paintBrand: new UntypedFormControl('')
    });

    constructor(private headerService: HeaderService, private apiServices: IxellAPIService, private storage: StorageService, private router: Router, private translateService: TranslateService) { }


    changeCompanyFormCountryFacturation() {

        console.log("changeCompanyFormCountryFacturation");

        if (this.companyForm.value["country"] != "" && this.companyForm.value["country"] != undefined) {
            var tvaRegEx = Constants.countries.find(c => c.name.toLowerCase() == this.companyForm.value["country"].toLowerCase()).tvaRegEx;
            if (tvaRegEx != "") {
                this.companyForm.controls['tva'].setValidators([Validators.required, Validators.pattern(Constants.countries.find(c => c.name.toLowerCase() == this.companyForm.value["country"].toLowerCase()).tvaRegEx)]);
                this.companyForm.controls['tva'].updateValueAndValidity();
                //this.tvaCkeck = true;
            } else {
                this.companyForm.controls['tva'].clearValidators();
                this.companyForm.controls['tva'].updateValueAndValidity();
                if (this.companyForm.value.tva != "") {
                    this.companyForm.controls["tva"].setValue("");
                }
                //this.tvaCkeck = false;
            }
        }
    }

    changeOtherCustomerFormCountryFacturation() {
        if (this.otherCustomerForm.value["country"] != "" && this.otherCustomerForm.value["country"] != undefined) {
            var tvaRegEx = Constants.countries.find(c => c.name.toLowerCase() == this.otherCustomerForm.value["country"].toLowerCase()).tvaRegEx;
            if (tvaRegEx != "") {
                this.otherCustomerForm.controls['tva'].setValidators([Validators.required, Validators.pattern(Constants.countries.find(c => c.name.toLowerCase() == this.otherCustomerForm.value["country"].toLowerCase()).tvaRegEx)]);
                this.otherCustomerForm.controls['tva'].updateValueAndValidity();
                //this.tvaCkeck = true;
            } else {
                this.otherCustomerForm.controls['tva'].clearValidators();
                this.otherCustomerForm.controls['tva'].updateValueAndValidity();
                if (this.otherCustomerForm.value.tva != "") {
                    this.otherCustomerForm.controls["tva"].setValue("");
                }
                //this.tvaCkeck = false;
            }
        }
    }

    changeEditCustomerFormCountryFacturation() {
        if (this.editCustomerForm.value["country"] != "" && this.editCustomerForm.value["country"] != undefined) {
            var tvaRegEx = Constants.countries.find(c => c.name.toLowerCase() == this.editCustomerForm.value["country"].toLowerCase()).tvaRegEx;
            if (tvaRegEx != "") {
                this.editCustomerForm.controls['tva'].setValidators([Validators.required, Validators.pattern(Constants.countries.find(c => c.name.toLowerCase() == this.editCustomerForm.value["country"].toLowerCase()).tvaRegEx)]);
                this.editCustomerForm.controls['tva'].updateValueAndValidity();
                //this.tvaCkeck = true;
            } else {
                this.editCustomerForm.controls['tva'].clearValidators();
                this.editCustomerForm.controls['tva'].updateValueAndValidity();
                if (this.editCustomerForm.value.tva != "") {
                    this.editCustomerForm.controls["tva"].setValue("");
                }
                //this.tvaCkeck = false;
            }
        }
    }

    /**
     *
     * */
    ngOnInit() {

        this.isPreprod = Utils.IsPreprod();
        //document.getElementById("infoPreprodModal").style.display = "block";


        this.headerService.changeCanBack(true);
        this.roleSub = this.headerService.currentRole.subscribe(role => {
            this.role = role;
            this.isAdminLacour = Utils.isAdminLacour(role);
        });
        this.headerService.changeTitle(this.translateService.instant('manageaccount.manageTitle'));

        /* recupération pays user et vérif qu'il a bien un pays */
        this.country = this.storage.get("country");
        if (this.country == "null") { this.country = ""; }

        /* recupération pays selon droits unisite (Admin ont droit a tous pays et autres à un seul pays) */
        if (Utils.isAdminRenault(this.role) || Utils.isAdminRenaultPays(this.role) || Utils.isAdminLacour(this.role)) {
            this.countries = Utils.countries();
        } else {
            this.countries = Utils.countriesFiltered(this.country);
        }
        if (this.country) {
            let cntry = this.countries.find(c => c.name.toLowerCase() == this.country.toLowerCase() || c.vo.toLowerCase() == this.country.toLowerCase()).name;
            this.searchCustomerForm.setValue({
                country: cntry,
                postalCode: "",
                clientFilter: 0,
                clientOfId: null
            });
            this.refreshCTCList(cntry);
            this.getRegions(false, "new", false);
        }
        this.languages = Utils.languages();
        if (!Utils.isAdminRenault(this.role) && !Utils.isAdminRenaultPays(this.role)) {
            this.searchCustomerForm.controls['country'].disable({ onlySelf: true });
        }

        var pays = this.searchCustomerForm.controls['country'].value;
        let country = this.countries.find(c => c.name.toLowerCase() == pays.toLowerCase() || c.vo.toLowerCase() == pays.toLowerCase()).name;
        if (country && country.toLowerCase() == "france") {
            this.annuaireIxell = true;
        } else {
            this.annuaireIxell = false;
            this.checkedAnnuaire = false;
        }

        if (Utils.isAdminLacour(this.role)) {
            this.displayedColumns.unshift("autoConnexion");
        }

    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    ngAfterViewInit() {
        this.customerForm.valueChanges.subscribe(data => {
            if (this.msgConfirmation == true) this.msgConfirmation = false;
        });
        this.editCustomerForm.valueChanges.subscribe(data => {
            if (this.msgConfirmation == true) this.msgConfirmation = false;
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    displayAnnuaire() {
        var pays = this.searchCustomerForm.controls['country'].value;
        let country = this.countries.find(c => c.name.toLowerCase() == pays.toLowerCase() || c.vo.toLowerCase() == pays.toLowerCase()).name;
        if (country && country.toLowerCase() == "france") {
            this.annuaireIxell = true;
        } else {
            this.annuaireIxell = false;
            this.checkedAnnuaire = false;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param name
     */
    displayModal(name: string) {
        let modal = document.getElementById(name);
        modal.style.display = "block";
        switch (name) {
            case 'new':
                this.editCustomerForm.markAsDirty();
                this.showMailForm = true;
                this.errorMsgMail = false;
                this.companySelected = null;
                this.companyForm.reset();

                if (this.country) {
                    this.companyForm.controls["country"].setValue(this.countries.find(c => c.name.toLowerCase() == this.country.toLowerCase() || c.vo.toLowerCase() == this.country.toLowerCase()).name);
                }

                this.currentCustomer = new IColorUserV1();
                this.deleteMailCustomer = new IColorUserV1();
                this.deleteAccountCustomer = new IColorUserV1();
                this.otherCustomer = new IColorUserV1();

                break;
            case 'edit':
                break;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param name
     */
    closeModalPreprod(name: string) {
        let modal = document.getElementById(name);
        modal.style.display = "none";
        this.infoPreprod = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param name
     */
    closeModal(name: string) {
        let modal = document.getElementById(name);
        modal.style.display = "none";
        switch (name) {
            case 'new':
                this.similarCompanyForm.reset();
                this.dataCompanyForm.reset();
                this.customerForm.reset();
                this.customerEmailForm.reset();
                this.showCompanyForm = false;
                this.showListCompany = false;
                this.showVerifCompany = false;
                this.showCustomerCompany = false;
                this.showCustomerForm = false;
                this.errorMsgCompany = false;
                this.errorMsgVerifCompany = false;
                this.errorMsgCustomer = false;
                this.companySelected = null;
                this.dataCompanySelected = null;
                break;
            case 'edit':
                this.editCustomerForm.reset();

                if (this.languageChangeSub != null) {
                    this.languageChangeSub.unsubscribe();
                    this.languageChangeSub = null;
                }
                if (this.statsGetLastConnectionSub != null) {
                    this.statsGetLastConnectionSub.unsubscribe();
                    this.statsGetLastConnectionSub = null;
                }

                break;
        }
        this.showOther = false;
        this.otherCustomerForm.reset();
        this.emailExists = false;
        this.newCustomer = false;
        if (this.validationModal)
            this.searchCustomer();
        this.validationModal = false;
        this.envoiMailModal = false;
        this.haveScale = false;
        this.confirmationDeleteMail = false;
        this.confirmationDeleteAccount = false;
        this.newCustomer = false;
        this.msgConfirmation = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    initLanguage() {
        let language = this.storage.get("actualLanguage");
        this.customerForm.controls["language"].setValue(this.languages.find(c => c.code.toLowerCase() == language.toLowerCase()).name);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    refreshCTCList(country: string) {
        let pays = this.countries.find(c => c.name.toLowerCase() == country.toLowerCase() || c.vo.toLowerCase() == country.toLowerCase()).name;
        this.getLstCtcByCountrySub = this.apiServices.getLstCtcByCountry(pays).subscribe(data => {
            this.availableCTCs = data.filter(ctc => isNaN(Number(ctc.name)));
            if (this.getLstCtcByCountrySub != null) this.getLstCtcByCountrySub.unsubscribe();
        },
            error => {
                this.availableCTCs = [];
                if (this.getLstCtcByCountrySub != null) this.getLstCtcByCountrySub.unsubscribe();
            });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    showAddUserModal() {
        this.newCustomer = true;
        this.customerForm.controls['haveScale'].setValidators([Validators.required]);
        this.customerForm.controls['paintBrand'].setValidators([]);
        this.companyForm.setValue({
            socialReason: "",
            address: "",
            postalCode: "",
            city: "",
            country: this.country,
            siren: "",
            tva: ""
        });

        this.changeCompanyFormCountryFacturation();

        this.customerForm.setValue({
            name: "",
            firstName: "",
            mobile: "",
            phone: "",
            language: "",

            ctc: "",
            idCtc: 0,

            businessCode: this.regions.length == 1 ? this.regions[0] : '',
            customerNumber: "",
            customerCode: "",
            compteTresor: "",
            haveScale: false,
            paintBrand: ""
        });
        this.customerEmailForm.updateValueAndValidity();
        this.companyForm.updateValueAndValidity();
        this.customerForm.updateValueAndValidity();
        this.displayModal("new");
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param other
     * @param type
     * @param initCtc
     */
    getRegions(other: boolean, type: string, initCtc: boolean) {

        var customerForm;
        var companyCountry;
        switch (type) {
            case ('new'):
                customerForm = this.customerForm;
                companyCountry = this.companyForm.controls['country'].value;
                break;
            case ('edit'):
                customerForm = this.editCustomerForm;
                companyCountry = this.editCustomerForm.controls['country'].value;
                break;
        }

        if (companyCountry && (companyCountry.toLowerCase() == "france" || companyCountry.toLowerCase() == "spain" || companyCountry.toLowerCase() == "united kingdom")) {
            this.regionsSub = this.apiServices.getRegions(companyCountry).subscribe(data => {
                if (data) {
                    this.regions = data;
                }
                if (this.regionsSub != null) this.regionsSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.regionsSub != null) this.regionsSub.unsubscribe();
            });
        }

        if (companyCountry && (companyCountry.toLowerCase() == "france" || companyCountry.toLowerCase() == "spain" || companyCountry.toLowerCase() == "united kingdom")) {
            this.mprRenault = true;
            customerForm.controls['businessCode'].setValidators([Validators.required]);
            customerForm.controls['businessCode'].markAsTouched();
        }
        else {
            this.mprRenault = false;
            customerForm.controls['businessCode'].setValidators([]);
            customerForm.controls['businessCode'].markAsTouched();
        }

        if (this.otherCustomerForm.value.country && (this.otherCustomerForm.value.country.toLowerCase() == "france" || this.otherCustomerForm.value.country.toLowerCase() == "spain" || this.otherCustomerForm.value.country.toLowerCase() == "united kingdom")) {
            this.mprRenaultOther = true;
            this.otherCustomerForm.controls['businessCode'].setValidators([Validators.required]);
        }
        else {
            this.mprRenaultOther = false;
            this.otherCustomerForm.controls['businessCode'].setValidators([]);
        }
        this.otherCustomerForm.controls['businessCode'].updateValueAndValidity();
        customerForm.controls['businessCode'].updateValueAndValidity();

        if (initCtc) {
            this.loadCtcOfDrCustomer(type, "region");
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Ajout d'un nouvel utilisateur
     * */
    validMailForm() {
        setTimeout(() => {
            if (this.emailExists == false) {
                if (this.customerEmailForm.valid) {
                    this.showCompanyForm = true;
                    this.showMailForm = false;
                }
                else {
                    this.customerEmailForm.markAllAsTouched();
                }
            }
        }, 500);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Vue Formulaire Société
     * */
    searchSimilarCompany() {
        if (this.companyForm.status == "VALID" && this.customerEmailForm.status == "VALID") {
            this.companyEntered = new IColorUserV1;
            this.companyEntered.socialReason = this.companyForm.controls['socialReason'].value;
            this.companyEntered.address = this.companyForm.controls['address'].value;
            this.companyEntered.postalCode = this.companyForm.controls['postalCode'].value;
            this.companyEntered.city = this.companyForm.controls['city'].value;
            this.companyEntered.country = this.companyForm.controls['country'].value;
            this.companyEntered.siren = this.companyForm.controls['siren'].value;
            this.companyEntered.tva = this.companyForm.controls['tva'].value;
            this.similarCustomers = [];
            this.similarCompany = [];
            this.companySelected = null;
            this.customerSelected = null;
            this.similarCompanyForm.controls['similarCompany'].reset();
            var pays = this.companyForm.controls['country'].value;
            let country = this.countries.find(c => c.name.toLowerCase() == pays.toLowerCase() || c.vo.toLowerCase() == pays.toLowerCase()).name;
            var postalCode = this.companyForm.value.postalCode;
            var city = this.companyForm.value.city;
            this.getSimilarCompanySub = this.apiServices.getSimilarCompany(country, postalCode, city).subscribe(data => {

                console.log(data);

                if (data.length > 0) {
                    this.showListCompany = true;
                    this.similarCompany = data;
                }
                else {
                    this.isNewCompany = true;
                    this.displayCustomerForm();
                    this.initLanguage();
                    this.newCustomer = true;
                }
                this.showMailForm = false;
                this.showCompanyForm = false;
                if (this.getSimilarCompanySub != null) this.getSimilarCompanySub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.getSimilarCompanySub != null) this.getSimilarCompanySub.unsubscribe();
            })
        }
        else {
            this.companyForm.markAllAsTouched();
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    returnToMailForm() {
        this.showCompanyForm = false;
        this.showMailForm = true;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Vue Liste des sociétés
     * @param value
     */
    chooseCompany(value: any) {
        if (this.companySelected != null && this.companySelected != value) {
            this.dataCompanyForm.reset();
            this.dataCompanySelected = null;
            this.customerCompanyForm.reset();
            this.customerSelected = null;
            this.customerForm.reset();
        }
        this.companySelected = value;
        this.errorMsgCompany = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    selectCompany() {
        if (this.similarCompanyForm.status == 'VALID') {
            if (this.companySelected != null) {
                this.errorMsgCompany = false;
                this.showListCompany = false;
                if (this.companySelected == "new") {
                    this.isNewCompany = true;
                    this.showCustomerForm = true;
                    this.initLanguage();
                }
                else {
                    this.showVerifCompany = true;
                    this.isNewCompany = false;
                }
            }
        }
        else {
            this.similarCompanyForm.markAllAsTouched();
            this.errorMsgCompany = true;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    displayCompanyForm() {
        this.showCompanyForm = true;
        this.showListCompany = false;
        this.errorMsgCompany = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Vue Vérification données société
     * @param value
     */
    selectInfosCompany(value: any) {
        this.dataCompanySelected = value;
        this.errorMsgVerifCompany = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    displayListCustomers() {
        if (this.dataCompanyForm.status == 'VALID') {
            if (this.dataCompanySelected != null) {
                this.showVerifCompany = false;
                this.errorMsgVerifCompany = false;
                if (this.companySelected == "new") {
                    this.isNewCompany = true;
                    this.showCustomerForm = true;
                    this.initLanguage();
                    this.showListCompany = false;
                }
                else {
                    this.isNewCompany = false;
                    this.getCustomersCompanySub = this.apiServices.getListUsersById(this.companySelected.listIdcolorUser).subscribe(data => {
                        this.similarCustomers = data;
                        this.showCustomerCompany = true;
                        this.showListCompany = false;
                        if (this.getCustomersCompanySub != null) this.getCustomersCompanySub.unsubscribe();
                    }, error => {
                        console.log(error);
                        if (this.getCustomersCompanySub != null) this.getCustomersCompanySub.unsubscribe();
                    })
                }
            }
        }
        else {
            this.errorMsgVerifCompany = true;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    displayListCompany() {
        this.showVerifCompany = false;
        this.showListCompany = true;
        this.errorMsgVerifCompany = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Vue Liste des utilisateurs de la société sélectionnée
     * @param value
     */
    select(value: any) {
        this.customerSelected = value;
        this.errorMsgCustomer = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    displayCustomerForm() {

        var country = this.companyForm.controls['country'].value
        let pays = this.countries.find(c => c.name.toLowerCase() == country.toLowerCase() || c.vo.toLowerCase() == country.toLowerCase()).name;
        this.getCtcSub = this.apiServices.getLstCtcByCountryAndOrDR(pays, this.customerForm.value.businessCode).subscribe(data => {
            this.ctcsFiltered = data;
            if (this.getCtcSub != null) this.getCtcSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.getCtcSub != null) this.getCtcSub.unsubscribe();
        });

        if (this.similarCompany.length > 0) {
            if (this.customerCompanyForm.status == 'VALID') {
                this.customerForm.controls['paintBrand'].setValidators([]);
                this.customerForm.controls['haveScale'].setValidators([]);
                this.errorMsgCustomer = false;
                this.showCustomerForm = true;
                this.showCustomerCompany = false;
                if (this.country) {
                    this.companyForm.controls["country"].setValue(this.countries.find(c => c.name.toLowerCase() == this.country.toLowerCase() || c.vo.toLowerCase() == this.country.toLowerCase()).name);
                }
                let language = this.storage.get("actualLanguage");
                this.customerForm.controls["language"].setValue(this.languages.find(c => c.code.toLowerCase() == language.toLowerCase()).name);

                if (this.customerSelected != 'new' && this.customerSelected != null) {
                    this.customerForm.controls["name"].setValue(this.customerSelected.name);
                    this.customerForm.controls["firstName"].setValue(this.customerSelected.firstname);
                    this.customerForm.controls["mobile"].setValue(this.customerSelected.mobilePhone);
                    this.customerForm.controls["phone"].setValue(this.customerSelected.phone);
                    this.customerForm.controls["language"].setValue(this.customerSelected.language);

                    this.customerForm.controls["ctc"].setValue(this.customerSelected.ctc);
                    this.customerForm.controls["idCtc"].setValue(this.customerSelected.idCtc);

                    this.customerForm.controls["businessCode"].setValue(this.customerSelected.businessCode);
                    this.customerForm.controls["customerNumber"].setValue(this.customerSelected.mrpAccount);
                    this.customerForm.controls["customerCode"].setValue(this.customerSelected.customerCode);
                    this.customerForm.controls["compteTresor"].setValue(this.customerSelected.compteTresor);
                    this.newCustomer = false;
                }
                else if (this.customerSelected == 'new') {
                    this.newCustomer = true;
                    this.initLanguage();
                }
            }
            else {
                this.customerCompanyForm.markAllAsTouched();
                this.errorMsgCustomer = true;
            }
        }
        else {
            if (this.companyForm.status == 'VALID') {
                this.showCustomerForm = true;
            }
            else {
                this.companyForm.markAllAsTouched();
            }
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    displayVerifCompany() {
        this.showCustomerCompany = false;
        this.showVerifCompany = true;
        this.errorMsgCustomer = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Vue Formulaire Utilisateur
     * */
    getPreviousCustomerForm() {
        this.showCustomerForm = false;
        this.customerForm.reset();
        if (this.companySelected != null) {
            if (this.companySelected == 'new') {
                this.showListCompany = true;
            }
            else {
                this.showCustomerCompany = true;
            }
        }
        else {
            this.showCompanyForm = true;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param bool
     */
    newCustomerHaveScale(bool: boolean) {
        let res: any;
        if (bool) {
            this.customerForm.controls['paintBrand'].setValidators([Validators.required]);
            res = 1;
        }
        else {
            this.customerForm.controls['paintBrand'].setValidators([]);
            res = 2;
        }

        this.haveScale = bool;
        this.customerForm.setValue({
            name: this.customerForm.value.name,
            firstName: this.customerForm.value.firstName,
            mobile: this.customerForm.value.mobile,
            phone: this.customerForm.value.phone,
            language: this.customerForm.value.language,

            ctc: this.customerForm.value.ctc,
            idCtc: this.customerForm.value.idCtc,

            businessCode: this.customerForm.value.businessCode,
            customerNumber: this.customerForm.value.customerNumber,
            customerCode: this.customerForm.value.customerCode,
            compteTresor: this.customerForm.value.compteTresor,
            haveScale: res,
            paintBrand: this.customerForm.value.paintBrand
        });

        this.customerForm.controls['paintBrand'].updateValueAndValidity();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    searchCustomer() {
        if (this.searchCustomerForm.valid) {
            let postalCode = this.searchCustomerForm.value.postalCode;
            var pays = this.searchCustomerForm.controls['country'].value;
            let country = this.countries.find(c => c.name.toLowerCase() == pays.toLowerCase() || c.vo.toLowerCase() == pays.toLowerCase()).name;
            let annuaireIxell = this.checkedAnnuaire;

            var clientFilter = this.searchCustomerForm.controls['clientFilter'].value;
            var clientOfId = this.searchCustomerForm.controls['clientOfId'].value;

            let ctcId = (clientFilter < 2) ? (clientFilter - 1) : (Number(clientOfId));

            this.searchCustomersSub = this.apiServices.getClientsByCountryAndPostalCodeAndIdCTC(country, postalCode, ctcId, annuaireIxell).subscribe(data => {
                if (data) {
                    this.customersSource = null;
                    this.customersLst = data;
                    if (this.customersLst.length > 0) {
                        this.noResults = false;
                        this.customersSource = new MatTableDataSource(this.customersLst.slice());
                    }
                    else {
                        this.noResults = true;
                    }
                }
                if (this.searchCustomersSub != null) this.searchCustomersSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.searchCustomersSub != null) this.searchCustomersSub.unsubscribe();
            });
        }
    }


    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Masquer
     * @param customer
     */
    openDeleteAccountModal(customer: IColorUserV1) {
        this.confirmationDeleteAccount = true;
        this.deleteAccountCustomer = customer;
        this.displayModal("confirmationDeleteAccountModal");
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    hiddeCustomer() {
        this.hiddeCustomerSub = this.apiServices.hiddeCustomer(this.deleteAccountCustomer.idcolorUser, "ManageColorUser").subscribe(data => {
            if (data) {
                this.searchCustomer();
                this.closeModal('confirmationDeleteAccountModal');
            }
        }, error => {
            console.log(error);
            if (this.hiddeCustomerSub != null) this.hiddeCustomerSub.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Supprimer la date d'envoi
     * @param customer
     */
    openDeleteMailModal(customer: IColorUserV1) {
        this.confirmationDeleteMail = true;
        this.deleteMailCustomer = customer
        this.displayModal('confirmationDeleteMailModal');
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    deleteDateMail() {
        this.deleteDateMailSub = this.apiServices.deleteDateMail(this.deleteMailCustomer.idcolorUser, "ManageColorUser").subscribe(data => {
            if (data) {
                this.searchCustomer();
                this.closeModal('confirmationDeleteMailModal');
            }
        }, error => {
            console.log(error);
            if (this.deleteDateMailSub != null) this.deleteDateMailSub.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Modale Editer
     * @param customer
     */
    editCustomer(customer: IColorUserV1) {
        //this.haveTwoMail = false;
        this.haveMailPrincipal = (customer.mail) ? true : false;
        this.haveMailSecondaire = (customer.emergencyMail) ? true : false;
        this.changeMailPrincipal = customer.mail;
        this.haveChangeMailPrincipal = false;
        this.showEditForm = true;
        this.editCustomerForm.controls['haveScale'].setValidators([]);
        this.editCustomerForm.controls['paintBrand'].setValidators([]);
        this.currentCustomer = customer;
        let tmpCountry: any = this.countries.find(c => c.name.toLowerCase() == this.currentCustomer.country.toLowerCase() || c.vo.toLowerCase() == this.currentCustomer.country.toLowerCase());
        if (tmpCountry) {
            tmpCountry = tmpCountry.name;
        } else {
            tmpCountry = this.currentCustomer.country;
        }
        this.editCustomerForm.setValue({
            email: this.currentCustomer.mail,
            name: this.currentCustomer.name,
            firstName: this.currentCustomer.firstname,
            mobile: this.currentCustomer.mobilePhone,
            phone: this.currentCustomer.phone,
            socialReason: this.currentCustomer.socialReason,
            address: this.currentCustomer.address,
            postalCode: this.currentCustomer.postalCode,
            city: this.currentCustomer.city,
            country: tmpCountry,
            language: this.currentCustomer.language,

            ctc: this.currentCustomer.ctcName,
            idCtc: this.currentCustomer.idCtc,

            businessCode: this.currentCustomer.businessCode,
            customerNumber: this.currentCustomer.mrpAccount,
            customerCode: this.currentCustomer.customerCode,
            compteTresor: this.currentCustomer.compteTresor,
            haveScale: this.currentCustomer.haveScale,
            paintBrand: this.currentCustomer.paintBrand,
            emergencyMail: this.currentCustomer.emergencyMail,

            siren: this.currentCustomer.siren,
            tva: this.currentCustomer.tva

        });

        this.editCustomerForm.updateValueAndValidity();
        this.checkMail(this.editCustomerForm.value.email, 'edit');

        this.loadCtcOfDrCustomer("edit", "initEdit");

        if (this.languageChangeSub != null) {
            this.languageChangeSub.unsubscribe();
            this.languageChangeSub = null;
        }
        if (this.statsGetLastConnectionSub != null) {
            this.statsGetLastConnectionSub.unsubscribe();
            this.statsGetLastConnectionSub = null;
        }

        this.refreshLastConnectionDate(this.currentCustomer.mail);

        this.languageChangeSub = this.translateService.onLangChange.subscribe(() => {
            this.refreshLastConnectionDate(this.currentCustomer.mail);
        });

        this.displayModal('edit');
    }

    refreshLastConnectionDate(mail: string) {
        let language = this.storage.get("actualLanguage");
        if (language == "" || language == null)
            language = "fr";

        this.statsGetLastConnectionSub = this.apiServices.statsGetLastConnection(mail, language, moment().utcOffset() / 60).subscribe(data => {
            this.lastConnectionDate = data;
            if (this.statsGetLastConnectionSub != null) this.statsGetLastConnectionSub.unsubscribe();
        },
            error => {
                this.lastConnectionDate = "";
                if (this.statsGetLastConnectionSub != null) this.statsGetLastConnectionSub.unsubscribe();
            });
    }

    openSeeMoreModal(customer: IColorUserV1) {
        this.seeMoreCustomer = customer;
        this.displayModal('seeMore');
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param bool
     */
    customerHaveScale(bool: boolean) {
        let res: any;
        if (bool) {
            this.editCustomerForm.controls['paintBrand'].setValidators([Validators.required]);
            res = 1;
        }
        else {
            this.editCustomerForm.controls['paintBrand'].setValidators([]);
            res = 2;
        }

        this.haveScale = bool;
        this.editCustomerForm.setValue({
            email: this.editCustomerForm.value.email,
            name: this.editCustomerForm.value.name,
            firstName: this.editCustomerForm.value.firstName,
            mobile: this.editCustomerForm.value.mobile,
            phone: this.editCustomerForm.value.phone,
            socialReason: this.editCustomerForm.value.socialReason,
            address: this.editCustomerForm.value.address,
            postalCode: this.editCustomerForm.value.postalCode,
            city: this.editCustomerForm.value.city,
            country: this.editCustomerForm.value.country,
            language: this.editCustomerForm.value.language,

            ctc: this.editCustomerForm.value.ctc,
            idCtc: this.editCustomerForm.value.idCtc,

            businessCode: this.editCustomerForm.value.businessCode,
            customerNumber: this.editCustomerForm.value.customerNumber,
            customerCode: this.editCustomerForm.value.customerCode,
            compteTresor: this.editCustomerForm.value.compteTresor,
            haveScale: res,
            paintBrand: this.editCustomerForm.value.paintBrand,
            emergencyMail: this.currentCustomer.emergencyMail,

            siren: this.editCustomerForm.value.siren,
            tva: this.editCustomerForm.value.tva
        });

        this.editCustomerForm.controls['paintBrand'].updateValueAndValidity();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * commun
     * @param mail
     * @param type
     */
    checkMail(mail: string, type: string) {
        if (type == 'edit') {
            this.haveChangeMailPrincipal = (mail != this.changeMailPrincipal);
        }
        this.emailExists = false;
        this.hideOtherCustomer(type);
        this.otherCustomer = new IColorUserV1();
        this.checkMailSub = this.apiServices.checkMail(mail, this.currentCustomer.idcolorUser).subscribe(data => {
            if (data) {
                this.emailExists = true;
                this.otherCustomer = data;
                if (type == 'edit') this.showEditForm = false;
            }
            else {
                if (type == 'edit') this.showEditForm = true;
            }
            this.getRegions(false, type, false);
        }, error => {
            console.log(error);
            if (this.checkMailSub != null) this.checkMailSub.unsubscribe();
        });
        this.errorMsgMail = this.customerEmailForm.valid ? false : true;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    showOtherCustomer(type: string) {
        this.otherCustomerForm.setValue({
            name: this.otherCustomer.name,
            firstName: this.otherCustomer.firstname,
            mobile: this.otherCustomer.mobilePhone,
            phone: this.otherCustomer.phone,
            socialReason: this.otherCustomer.socialReason,
            address: this.otherCustomer.address,
            postalCode: this.otherCustomer.postalCode,
            city: this.otherCustomer.city,
            country: this.otherCustomer.country,
            language: this.otherCustomer.language,

            ctc: this.otherCustomer.ctcName,
            idCtc: this.otherCustomer.idCtc,

            businessCode: this.otherCustomer.businessCode,
            customerNumber: this.otherCustomer.mrpAccount,
            customerCode: this.otherCustomer.customerCode,
            compteTresor: this.otherCustomer.compteTresor,

            siren: this.otherCustomer.siren,
            tva: this.otherCustomer.tva

        });
        if (this.otherCustomerForm.value.country && (this.otherCustomerForm.value.country.toLowerCase() == "france" || this.otherCustomerForm.value.country.toLowerCase() == "spain")) {
            this.mprRenaultOther = true;
            this.otherCustomerForm.controls['businessCode'].setValidators([Validators.required]);
        }
        else {
            this.mprRenaultOther = false;
            this.otherCustomerForm.controls['businessCode'].setValidators([]);
        }
        this.otherCustomerForm.controls['businessCode'].updateValueAndValidity();
        this.editCustomerForm.controls['businessCode'].updateValueAndValidity();

        switch (type) {
            case ('new'):
                this.showOther = true;
                break;
            case ('edit'):
                this.showOtherEdit = true;
                this.showEditForm = false;
                //this.showEditForm = false;
                break;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    hideOtherCustomer(type: string) {
        this.otherCustomerForm.reset();
        switch (type) {
            case ('new'):
                this.showOther = false;
                break;
            case ('edit'):
                this.showOtherEdit = false;
                break;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    saveOtherCustomer(type: string) {
        var mailForm;
        switch (type) {
            case ('new'):
                mailForm = this.customerEmailForm;
                break;
            case ('edit'):
                mailForm = this.editCustomerForm;
                break;
        }

        this.otherCustomer.mail = mailForm.value.email;
        this.otherCustomer.socialReason = this.otherCustomerForm.value.socialReason;
        this.otherCustomer.address = this.otherCustomerForm.value.address;
        this.otherCustomer.city = this.otherCustomerForm.value.city;
        this.otherCustomer.postalCode = this.otherCustomerForm.value.postalCode;
        this.otherCustomer.country = this.countries.find(c => c.name.toLowerCase() == this.otherCustomerForm.value.country.toLowerCase() || c.vo.toLowerCase() == this.otherCustomerForm.value.country.toLowerCase()).name;

        this.otherCustomer.name = this.otherCustomerForm.value.name;
        this.otherCustomer.firstname = this.otherCustomerForm.value.firstName;
        this.otherCustomer.mobilePhone = this.otherCustomerForm.value.mobile;
        this.otherCustomer.phone = this.otherCustomerForm.value.phone;
        this.otherCustomer.language = this.otherCustomerForm.value.language;

        this.otherCustomer.ctcName = this.otherCustomerForm.value.ctc;
        this.otherCustomer.idCtc = this.otherCustomerForm.value.idCtc;

        this.otherCustomer.businessCode = this.otherCustomerForm.value.businessCode;
        this.otherCustomer.customerCode = this.otherCustomerForm.value.customerCode;
        this.otherCustomer.mrpAccount = this.otherCustomerForm.value.customerNumber;
        this.otherCustomer.compteTresor = this.otherCustomerForm.value.compteTresor;

        this.otherCustomer.siren = this.otherCustomerForm.value.siren;
        this.otherCustomer.tva = this.otherCustomerForm.value.tva;

        if (this.otherCustomerForm.status == 'VALID') {
            this.newCustomer = false;
            this.sendID(this.otherCustomer, type);
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    initCurrentCustomer(type: string) {
        var email;
        var companyForm;
        var companyCountry;
        var customerForm;
        switch (type) {
            case ('new'):
                if (this.customerSelected != null && this.customerSelected != 'new') {
                    email = this.customerSelected.mail;
                    this.currentCustomer.idcolorUser = this.customerSelected.idcolorUser;
                }
                else {
                    email = this.customerEmailForm.value.email;
                }
                if (this.isNewCompany == false && this.dataCompanySelected == this.companySelected) // données récupérées
                {
                    companyForm = this.companySelected;
                    companyCountry = this.companySelected.country;
                }
                else // données saisies
                {
                    companyForm = this.companyForm.value;
                    companyCountry = this.companyForm.controls['country'].value;
                }
                customerForm = this.customerForm;
                break;
            case ('edit'):
                email = this.editCustomerForm.value.email;
                companyForm = this.editCustomerForm.value;
                companyCountry = this.editCustomerForm.controls['country'].value;
                customerForm = this.editCustomerForm;
                this.currentCustomer.emergencyMail = this.editCustomerForm.value.emergencyMail;
                break;
        }
        this.currentCustomer.mail = email;
        this.currentCustomer.socialReason = companyForm.socialReason;
        this.currentCustomer.address = companyForm.address;
        this.currentCustomer.city = companyForm.city;
        this.currentCustomer.postalCode = companyForm.postalCode;
        this.currentCustomer.country = this.countries.find(c => c.name.toLowerCase() == companyCountry.toLowerCase() || c.vo.toLowerCase() == companyCountry.toLowerCase()).name;

        this.currentCustomer.name = customerForm.value.name;
        this.currentCustomer.firstname = customerForm.value.firstName;
        this.currentCustomer.mobilePhone = customerForm.value.mobile;
        this.currentCustomer.phone = customerForm.value.phone;
        this.currentCustomer.language = customerForm.value.language;

        this.currentCustomer.ctcName = customerForm.value.ctc;
        this.currentCustomer.idCtc = customerForm.value.idCtc;

        this.currentCustomer.businessCode = customerForm.value.businessCode;
        this.currentCustomer.customerCode = customerForm.value.customerCode;
        this.currentCustomer.mrpAccount = customerForm.value.customerNumber;
        this.currentCustomer.compteTresor = customerForm.value.compteTresor;

        this.currentCustomer.siren = customerForm.value.siren;
        this.currentCustomer.tva = customerForm.value.tva;

        var valueHaveScale = ((customerForm.value.haveScale == false || customerForm.value.haveScale == null) ? 2 : customerForm.value.haveScale);
        this.currentCustomer.haveScale = valueHaveScale;
        this.currentCustomer.paintBrand = customerForm.value.paintBrand;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    saveAndSendCustomer() {
        this.initCurrentCustomer('new');
        var customerForm = this.customerForm;
        customerForm = this.customerForm;
        if (customerForm.status == 'VALID') {
            this.sendID(this.currentCustomer, 'new');
        }
        else {
            this.envoiMailModal = true;
            customerForm.markAllAsTouched();
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param customer
     * @param type
     */
    sendID(customer: IColorUserV1, type: string) {
        this.saveAndSendIDSub = this.apiServices.saveColorUserAndSendID(customer, this.newCustomer, type, "ManageColorUser").subscribe(data => {
            if (data == true) {
                this.mailCustomer = customer.mail;
                this.closeModal(type);
                this.validationModal = true;
                this.displayModal('validationModal');
            }

            if (this.isPreprod && !this.isAdminLacour) {
                this.infoPreprod = true;
                document.getElementById("infoPreprodModal").style.display = "block";
            }

        }, error => {
            console.log(error);
            if (this.saveAndSendIDSub != null) this.saveAndSendIDSub.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    saveCustomer(type: string) {

        this.initCurrentCustomer(type);
        var form = (type == "new") ? this.customerForm : this.editCustomerForm;
        if (form.status == 'VALID') {
            this.saveSub = this.apiServices.saveColorUser(this.currentCustomer, this.newCustomer, type, "ManageColorUser", true).subscribe(data => {
                if (this.currentCustomer.emergencyMail) {
                    this.tmpCurrentCustomerMail = this.currentCustomer.mail;
                    this.currentCustomer.mail = this.currentCustomer.emergencyMail;
                    this.currentCustomer.emergencyMail = null;
                    this.saveSub = this.apiServices.saveColorUserEmergency(this.currentCustomer, "ManageColorUser", true).subscribe(data => {
                        this.currentCustomer.emergencyMail = this.currentCustomer.mail;
                        this.currentCustomer.mail = this.tmpCurrentCustomerMail;
                        this.msgConfirmation = true;
                    }, error => {
                        console.log(error);
                        if (this.saveSub != null) this.saveSub.unsubscribe();
                    });
                } else {
                    this.msgConfirmation = true;
                }

                if (this.isPreprod && !this.isAdminLacour) {
                    this.infoPreprod = true;
                    document.getElementById("infoPreprodModal").style.display = "block";
                }

            }, error => {
                console.log(error);
                if (this.saveSub != null) this.saveSub.unsubscribe();
            });
        }
        else {
            form.markAllAsTouched();
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    saveAndSendCustomerEdit() {

        //console.log(this.currentCustomer);

        //if (type == 'edit') {
        this.haveChangeMailPrincipal = (this.editCustomerForm.value.email != this.changeMailPrincipal);
        //}
        this.emailExists = false;
        this.hideOtherCustomer("edit");
        this.otherCustomer = new IColorUserV1();
        this.checkMailSub = this.apiServices.checkMail(this.editCustomerForm.value.email, this.currentCustomer.idcolorUser).subscribe(data => {
            if (data) {
                this.emailExists = true;
                this.otherCustomer = data;
                this.showEditForm = false;
            }
            else {
                this.showEditForm = true;

                this.initCurrentCustomer('edit');
                var customerForm = this.editCustomerForm;
                if (customerForm.status == 'VALID') {
                    this.openEnvoiMailIdentifiant('edit');
                }
                else {
                    this.envoiMailModal = true;
                    customerForm.markAllAsTouched();
                }
            }

            this.getRegions(false, "edit", false);
        }, error => {
            console.log(error);
            if (this.checkMailSub != null) this.checkMailSub.unsubscribe();
        });
        this.errorMsgMail = this.customerEmailForm.valid ? false : true;


    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    openEnvoiMailIdentifiant(type: string) {
        this.closeModal(type);
        this.envoiMailModal = true;
        this.haveMailPrincipal = (this.currentCustomer.mail) ? true : false;
        this.haveMailSecondaire = (this.currentCustomer.emergencyMail) ? true : false;
        /*this.haveChangeMailPrincipal = (this.changeMailPrincipal != this.currentCustomer.mail);*/
        this.checkBoxMailPrincipal = this.haveChangeMailPrincipal;
        this.checkBoxMailSecondaire = false;
        this.mailCustomer = this.currentCustomer.mail;
        this.emergencyMailCustomer = this.currentCustomer.emergencyMail;
        this.displayModal('envoiMailModal');
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param check
     */
    envoiMailCheckMail(check: string) {
        switch (check) {
            case 'principal':
                this.checkBoxMailPrincipal = !this.checkBoxMailPrincipal;
                break;
            case 'secondaire':
                this.checkBoxMailSecondaire = !this.checkBoxMailSecondaire;
                break;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    envoiMailIdentifiant() {
        // si adresse mail coché
        if (this.checkBoxMailPrincipal) {
            this.saveAndSendIDSub = this.apiServices.saveColorUserAndSendID(this.currentCustomer, this.newCustomer, 'edit', "ManageColorUser").subscribe(data => {
                if (data == true) {
                    // si adresse mail secondaire coché
                    if (this.checkBoxMailSecondaire) {
                        this.tmpCurrentCustomerMail = this.currentCustomer.mail;
                        this.currentCustomer.mail = this.currentCustomer.emergencyMail;
                        this.currentCustomer.emergencyMail = null;
                        this.saveAndSendIDSub = this.apiServices.saveColorUserEmergencyAndSendID(this.currentCustomer, 'edit', "ManageColorUser").subscribe(data => {
                            if (data == true) {
                                this.currentCustomer.emergencyMail = this.currentCustomer.mail;
                                this.currentCustomer.mail = this.tmpCurrentCustomerMail;
                                this.emergencyMailCustomer = this.currentCustomer.emergencyMail;
                                this.mailCustomer = this.currentCustomer.mail;
                                this.closeModal('edit');
                                this.closeModal('envoiMailModal');
                                this.validationModal = true;
                                this.displayModal('validationModal');
                            }
                        }, error => {
                            console.log(error);
                            if (this.saveAndSendIDSub != null) this.saveAndSendIDSub.unsubscribe();
                        });
                    } else {
                        if (this.currentCustomer.emergencyMail) {
                            this.tmpCurrentCustomerMail = this.currentCustomer.mail;
                            this.currentCustomer.mail = this.currentCustomer.emergencyMail;
                            this.currentCustomer.emergencyMail = null;
                            this.saveSub = this.apiServices.saveColorUserEmergency(this.currentCustomer, "ManageColorUser", true).subscribe(data => {
                                this.currentCustomer.emergencyMail = this.currentCustomer.mail;
                                this.currentCustomer.mail = this.tmpCurrentCustomerMail;
                                this.validationModal = true;
                                this.closeModal('edit');
                                this.closeModal('envoiMailModal');
                            }, error => {
                                console.log(error);
                                if (this.saveSub != null) this.saveSub.unsubscribe();
                            });
                        } else {
                            this.mailCustomer = this.currentCustomer.mail;
                            this.closeModal('edit');
                            this.closeModal('envoiMailModal');
                            this.validationModal = true;
                            this.displayModal('validationModal');
                        }
                    }
                }

                if (this.isPreprod && !this.isAdminLacour) {
                    this.infoPreprod = true;
                    document.getElementById("infoPreprodModal").style.display = "block";
                }

            }, error => {
                console.log(error);
                if (this.saveAndSendIDSub != null) this.saveAndSendIDSub.unsubscribe();
            });
        } else {
            // si adresse mail secondaire coché
            if (this.checkBoxMailSecondaire) {
                this.tmpCurrentCustomerMail = this.currentCustomer.mail;
                this.currentCustomer.mail = this.currentCustomer.emergencyMail;
                this.currentCustomer.emergencyMail = null;
                this.saveAndSendIDSub = this.apiServices.saveColorUserEmergencyAndSendID(this.currentCustomer, 'edit', "ManageColorUser").subscribe(data => {
                    if (data == true) {
                        this.currentCustomer.emergencyMail = this.currentCustomer.mail;
                        this.currentCustomer.mail = this.tmpCurrentCustomerMail;
                        this.emergencyMailCustomer = this.currentCustomer.emergencyMail;
                        this.mailCustomer = '';
                        this.closeModal('edit');
                        this.closeModal('envoiMailModal');
                        this.validationModal = true;
                        this.displayModal('validationModal');
                    }

                    if (this.isPreprod && !this.isAdminLacour) {
                        this.infoPreprod = true;
                        document.getElementById("infoPreprodModal").style.display = "block";
                    }

                }, error => {
                    console.log(error);
                    if (this.saveAndSendIDSub != null) this.saveAndSendIDSub.unsubscribe();
                });
            }
        }
        if (!this.checkBoxMailPrincipal && !this.checkBoxMailSecondaire) {
            this.saveSub = this.apiServices.saveColorUser(this.currentCustomer, this.newCustomer, "edit", "ManageColorUser", true).subscribe(data => {
                if (this.currentCustomer.emergencyMail) {
                    this.tmpCurrentCustomerMail = this.currentCustomer.mail;
                    this.currentCustomer.mail = this.currentCustomer.emergencyMail;
                    this.currentCustomer.emergencyMail = null;
                    this.saveSub = this.apiServices.saveColorUserEmergency(this.currentCustomer, "ManageColorUser", true).subscribe(data => {
                        this.currentCustomer.emergencyMail = this.currentCustomer.mail;
                        this.currentCustomer.mail = this.tmpCurrentCustomerMail;
                        this.validationModal = true;
                        this.closeModal('edit');
                        this.closeModal('envoiMailModal');
                    }, error => {
                        console.log(error);
                        if (this.saveSub != null) this.saveSub.unsubscribe();
                    });
                } else {
                    this.validationModal = true;
                    this.closeModal('edit');
                    this.closeModal('envoiMailModal');
                }

                if (this.isPreprod && !this.isAdminLacour) {
                    this.infoPreprod = true;
                    document.getElementById("infoPreprodModal").style.display = "block";
                }

            }, error => {
                console.log(error);
                if (this.saveSub != null) this.saveSub.unsubscribe();
            });
        }
    }


    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Check si le mail du client en cours de modification à été modifier
     * @param mail
     */
    inputMail(mail: string) {
        this.haveChangeMailPrincipal = (this.changeMailPrincipal != mail);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param sort
     * @param status
     */
    sort(sort: Sort, status: string) {
        var data = this.customersLst;
        Constants.sortScale(sort, status, data)

        this.customersLst = data.slice();
        this.customersSource = new MatTableDataSource(this.customersLst);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    ngOnDestroy() {
        if (this.searchCustomersSub != null) this.searchCustomersSub.unsubscribe();
        if (this.checkMailSub != null) this.checkMailSub.unsubscribe();
        if (this.saveAndSendIDSub != null) this.saveAndSendIDSub.unsubscribe();
        if (this.saveSub != null) this.saveSub.unsubscribe();
        if (this.regionsSub != null) this.regionsSub.unsubscribe();
        if (this.hiddeCustomerSub != null) this.hiddeCustomerSub.unsubscribe();
        if (this.deleteDateMailSub != null) this.deleteDateMailSub.unsubscribe();
        if (this.getCustomerSub != null) this.getCustomerSub.unsubscribe();
        if (this.roleSub != null) this.roleSub.unsubscribe();
        if (this.getSimilarCompanySub != null) this.getSimilarCompanySub.unsubscribe();
        if (this.getCustomersCompanySub != null) this.getCustomersCompanySub.unsubscribe();
        if (this.getCtcSub != null) this.getCtcSub.unsubscribe();
        if (this.autoCoSub != null) this.autoCoSub.unsubscribe();
        if (this.statsGetLastConnectionSub != null) this.statsGetLastConnectionSub.unsubscribe();
        if (this.languageChangeSub != null) this.languageChangeSub.unsubscribe();
        if (this.getLstCtcByCountrySub != null) this.getLstCtcByCountrySub.unsubscribe();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param idColorUser
     */
    autoConnexion(idColorUser: number) {
        this.autoCoSub = this.apiServices.getAutoConnexionColorUser(idColorUser).subscribe(data => {
            this.router.navigate(['/home/' + data]);
        }, error => { if (this.autoCoSub != null) this.autoCoSub.unsubscribe(); });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    getCustomerByCtcId() {
        this.router.navigate(["historyaccount"]);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     * @param call
     */
    loadCtcOfDrCustomer(type: string, call: string) {
        var customerForm;
        var country;
        switch (type) {
            case ('new'):
                switch (call) {
                    case ("region"):
                        this.customerForm.controls["businessCode"].setValue("");
                        this.customerForm.controls["ctc"].setValue("");
                        this.customerForm.controls["idCtc"].setValue("");
                        break;
                    case ("dr"):
                        this.customerForm.controls["ctc"].setValue("");
                        this.customerForm.controls["idCtc"].setValue("");
                        break;
                }
                country = this.companyForm.controls['country'].value;
                customerForm = this.customerForm;
                if (country && (country.toLowerCase() == "france" || country.toLowerCase() == "spain" || country.toLowerCase() == "united kingdom") && !customerForm.value.businessCode) {
                    this.customerForm.get('idCtc').disable();
                } else {
                    this.customerForm.get('idCtc').enable();
                }
                break;
            case ('edit'):
                switch (call) {
                    case ("region"):
                        this.editCustomerForm.controls["businessCode"].setValue("");
                        this.editCustomerForm.controls["ctc"].setValue("");
                        this.editCustomerForm.controls["idCtc"].setValue("");
                        break;
                    case ("dr"):
                        this.editCustomerForm.controls["ctc"].setValue("");
                        this.editCustomerForm.controls["idCtc"].setValue("");
                        break;
                }
                country = this.editCustomerForm.value.country;
                customerForm = this.editCustomerForm;
                if (country && (country.toLowerCase() == "france" || country.toLowerCase() == "spain" || country.toLowerCase() == "united kingdom") && !customerForm.value.businessCode) {
                    this.editCustomerForm.get('idCtc').disable();
                } else {
                    this.editCustomerForm.get('idCtc').enable();
                }
                break;
        }

        let pays = this.countries.find(c => c.name.toLowerCase() == country.toLowerCase() || c.vo.toLowerCase() == country.toLowerCase()).name;
        this.getCtcSub = this.apiServices.getLstCtcByCountryAndOrDR(pays, customerForm.value.businessCode).subscribe(data => {
            this.ctcsFiltered = data;
            if (this.getCtcSub != null) this.getCtcSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.getCtcSub != null) this.getCtcSub.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    ctcSelected(type: string) {
        switch (type) {
            case ('new'):
                this.customerForm.value.ctc = this.ctcsFiltered.find(c => c.idCtc == this.customerForm.value.idCtc).firstname + " " + this.ctcsFiltered.find(c => c.idCtc == this.customerForm.value.idCtc).name;
                break;
            case ('edit'):
                this.editCustomerForm.value.ctc = this.ctcsFiltered.find(c => c.idCtc == this.editCustomerForm.value.idCtc).firstname + " " + this.ctcsFiltered.find(c => c.idCtc == this.editCustomerForm.value.idCtc).name;
                break;
        }
    }

}
